// Function to update the CSS custom property with the element's height
function updateElementHeight() {
    const elements = document.querySelectorAll("#keyvisual > div")
    const top      = elements[0]
    const bottom   = elements[elements.length - 1]

    if (top)    document.documentElement.style.setProperty('--keyvisual-top', `${top.offsetHeight}px`);
    if (bottom) document.documentElement.style.setProperty('--keyvisual-bottom', `${bottom.offsetHeight}px`);
}

// Update on load
window.addEventListener('load', updateElementHeight);

// Update on resize
window.addEventListener('resize', updateElementHeight);